import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { IWorkplaceGroupTableRecord } from '@api'
import { WorkplaceGroupTableRecordFragment } from '@api/fragments'
import { IEdge } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        workplaceGroups: {
          edges: IEdge<IWorkplaceGroupTableRecord>[]
        }
      }
    }
  }
}

export default function catalog(): Promise<IWorkplaceGroupTableRecord[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { workplaceGroups: items },
        },
      },
    }: Payload) => items.edges.map((i) => i.node)
  )
}

const query = gql`
  query WorkplaceGroups {
    viewer {
      company {
        workplaceGroups {
          edges {
            node {
              ...WorkplaceGroupTableRecordFragment
            }
          }
        }
      }
    }
  }
  ${WorkplaceGroupTableRecordFragment}
`
